import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import useViewport from 'Hooks/useViewport';

import 'Components/Order/OperaGxCard.scss';

export default function OperaGxCard() {
  const [userOs, setUserOs] = useState('');
  const [modal, setModal] = useState(false);

  const { isAboveSm } = useViewport();

  useEffect(() => {
    const platform = get(window, 'navigator.platform');
    if (platform.includes('Mac')) setUserOs('mac');
    if (platform.includes('Win')) setUserOs('windows');
  }, []);

  const toggle = () => {
    setModal(!modal);
  };

  if (userOs !== 'mac' && userOs !== 'windows') return false;

  let operaGxButtonLink = '';
  if (userOs === 'windows') operaGxButtonLink = 'https://net.geo.opera.com/opera_gx/stable/edition/std-1?utm_medium=pb&utm_source=playanext&utm_campaign=fanatical';
  if (userOs === 'mac') operaGxButtonLink = 'https://net.geo.opera.com/opera_gx/stable/mac/edition/std-1?utm_medium=pb&utm_source=playanext&utm_campaign=fanatical';

  return (
    <>
      <article className="OperaGxCard">
        {isAboveSm &&
          <div className="OperaGxCard__cover">
            <img src="https://cdn.fanatical.com/production/product/original/7ab3f4e7-6095-4869-bf22-29599353f3cd.png" alt="Opera GX: the browser for gamers" />
          </div>
        }
        <div className="OperaGxCard__details">
          <div className="OperaGxCard__details__text">
            <h4 className="OperaGxCard__details__text__heading">
              <FormattedMessage
                id="OperaGxCard.heading"
                defaultMessage="Opera GX: the browser for gamers"
              />
            </h4>
            <div className="OperaGxCard__details__text__install">
              <FormattedMessage
                id="OperaGxCard.install"
                defaultMessage="Included in your giveaway for free! Get unparalleled gaming and browsing experience on mobile and desktop."
              />
            </div>
          </div>
          <div className="OperaGxCard__details__button">
            <button className="btn btn-primary btn-block" onClick={() => { toggle(); }}>
              <FormattedMessage
                id="OperaGxCard.button.more"
                defaultMessage="Download Now"
              />
            </button>
          </div>
        </div>
      </article>

      <Modal isOpen={modal} toggle={toggle} className="account-modal account-modal--large">
        <ModalBody>
          <div className="account-modal-title">
            <FormattedMessage
              id="OperaGxCard.modal.title"
              defaultMessage="Opera GX: The browser for gamers"
            />
          </div>

          <div className="account-modal-form">
            <p className="account-modal-paragraph mb-0">
              <FormattedMessage
                id="OperaGxCard.modal.text"
                defaultMessage="Get unparalleled gaming and browsing experience on mobile and desktop."
              />
            </p>

            <div className="image-bullet-points-container">
              <div className="image-container">
                <img src="https://cdn.fanatical.com/production/product/original/7ab3f4e7-6095-4869-bf22-29599353f3cd.png" alt="Opera GX: the browser for gamers" />
              </div>
              <div className="bullet-points-container">
                <ul>
                  <li>
                    <FormattedMessage
                      id="OperaGxCard.bullets.one"
                      defaultMessage="Use 80% less RAM."
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id="OperaGxCard.bullets.two"
                      defaultMessage="CPU, RAM, and Network limiters."
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id="OperaGxCard.bullets.three"
                      defaultMessage="Integrated Twitch and Discord in sidebar."
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id="OperaGxCard.bullets.four"
                      defaultMessage="Built-in Free VPN."
                    />
                  </li>
                </ul>
              </div>
            </div>

            <div className="account-modal-form-buttons">
              <div className="form-button-container">
                <a href={operaGxButtonLink} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  <FormattedMessage
                    id="OperaGxCard.button.download"
                    defaultMessage="Free Download"
                  />
                </a>
              </div>
              <div className="form-button-container">
                <button className="btn btn-secondary" onClick={() => { toggle(); }}>
                  <FormattedMessage
                    id="OperaGxCard.button.no"
                    defaultMessage="No thanks"
                  />
                </button>
              </div>
            </div>
          </div>
        </ModalBody>

        <div className="close-button-container">
          <button aria-label="close" onClick={() => toggle()}>
            <FontAwesomeIcon icon={faXmark} title="Close modal" />
          </button>
        </div>
      </Modal>
    </>
  );
}
